<template lang="pug">
    components(:is="transformed")
</template>

<script>
export default {
    props: ["value", "formData", "formItem", "formKey"],
    computed: {
        transformed() {
            return { template: this.formItem ? this.formData[this.formItem.key] : this.formData[this.formKey] };
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/RawHTML.vue